import React from 'react'
import BarChartClassroomSkeleton from './BarChartClassroomSkeleton'

const YourClassRoomSkeleton = () => {
    return (
        <div className="bg-containerGray rounded-[10px] w-full flex justify-between h-[240px] items-center animate-pulse">
            <div className=" h-full flex items-center justify-between p-[35px] flex-col ">
                <div className="w-full flex flex-col">
                    <div className="h-6 bg-[#ecebf8] w-[80%] rounded mb-[5px]"></div>
                    <div className="h-4 bg-[#ecebf8] w-full rounded mb-[5px]"></div>
                </div>
                <div className="rounded-full bg-deepPurple flex items-center justify-center w-[150px] h-[50px] opacity-50"></div>
            </div>
            <div className="p-[35px] pl-0 w-full h-full flex justify-end">
                <div className=" w-full h-full relative">
                    <BarChartClassroomSkeleton />
                </div>
            </div>
        </div>
    )
}

export default YourClassRoomSkeleton
